/**
 * Created by Ivan on 19.10.2026
 */

cleverapps.override(cleverapps.EVENTS, {
    EARN: {
        DISCO_PARTY: "discoparty"
    }
});
